import { render, staticRenderFns } from "./CustomerTransactionsTable.vue?vue&type=template&id=3f98e27b"
import script from "./CustomerTransactionsTable.vue?vue&type=script&lang=js"
export * from "./CustomerTransactionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports